import { type FC, useEffect } from 'react';
import { writeFavorites } from '../favorites';
import { useStore } from '../store';

/**
 * Keeps the selected starters/POIs/tracks in localStorage, so they survive a lost url. The url
 * hash stays the primary carrier — this only mirrors it, see `getFavoritesToRestore` for the
 * restore side. Mounted by the player only, not by the embedded elevation chart.
 */
export const FavoritesManager: FC = () => {
  const eventId = useStore((state) => state.eventId);
  const selected = useStore((state) => state.timer.selected);

  useEffect(() => {
    if (eventId === '') return;

    writeFavorites(eventId, selected);
  }, [eventId, selected]);

  return null;
};
